<template>
  <card shadow type="secondary">
    <template #header>
      <div class="bg-white border-0">
        <div class="row align-items-center">
          <div class="col-8 text-start">
            <h5 class="mb-0">{{ $t("Analytics") }}</h5>
          </div>
          <div class="col-4 text-end">
            <router-link :to="'/clients/'+clientData.id+'/requests'" class="btn btn-primary btn-sm mt-1 mb-1">
              <span class="nav-link-text">{{ $t("View All") }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </template>

    <div class="pl-lg-4 text-start">
      <p class="text-muted mb-3">
        <i class="fa fa-chart-column me-2" aria-hidden="true"></i>
        {{ $t("See how many shifts were requested, filled and completed, with no-show and abandonment rates, costs per month and your top partners.") }}
      </p>
      <router-link :to="statisticsPath" class="btn btn-sm btn-outline-primary">
        {{ $t("Open statistics") }}
      </router-link>
    </div>
  </card>
</template>
<script>
export default {
  name: "client-requests-analytics-card",
  props: {
    clientData: {
      type: Object,
      description: "Client data",
    },
  },
  computed: {
    statisticsPath() {
      // Organizations have their own page; system users use the admin report.
      return this.$store.state.user.claims?.role === "CLIENT" ? "/statistics" : "/organizationStatistics"
    }
  },
}
</script>
<style></style>
